export default "__VITE_PUBLIC_ASSET__f62a6514__"